import { render } from "./ControlsPanel.vue?vue&type=template&id=45e55888&scoped=true&ts=true"
import script from "./ControlsPanel.vue?vue&type=script&lang=ts"
export * from "./ControlsPanel.vue?vue&type=script&lang=ts"

import "./ControlsPanel.vue?vue&type=style&index=0&id=45e55888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e55888"]])

export default __exports__